<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="data === undefined">
      <h4 class="alert-heading">
        Ошибка получения данных
      </h4>
      <div class="alert-body">
        Не удалось найти обьект с данным id. Проверьте
        <b-link
          class="alert-link"
          :to="{ name: 'railway_structure-contact_wire-list'}"
        >
          Список обьектов
        </b-link>
        список обьектов.
      </div>
    </b-alert>

    <template v-if="data">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <contact-wire-info-card :contact-wire-data="data" @open-tab="goTab" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <user-responsability-info-card :data="data.user"/>
        </b-col>
        <b-col>
          <b-tabs v-model="activeTab">
            <b-tab title="Замеры" lazy>
              <measurements-list :object-active-option="data.number"></measurements-list>
            </b-tab>

          </b-tabs>
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
  import store from '@/store'
  import router from '@/router'
  import {ref, onBeforeMount, onBeforeUnmount, onMounted} from '@vue/composition-api'

    import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../contactWireStoreModule'

  import {
    BCard, BCardBody, BCardTitle, BCardSubTitle, BTable, BRow, BCol, BAlert, BLink, BTabs, BTab
  } from 'bootstrap-vue'

  import useContactWire from '../useContactWire'

  import ContactWireInfoCard from '../components/ContactWireInfoCard.vue'
  import UserResponsabilityInfoCard from '@/views/apps/user/components/UserResponsabilityInfoCard.vue'
  import MeasurementsList from '@/views/apps/measurement/measurement/views/List.vue'


export default {
  components: {

    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BTable,
    BRow,
    BCol,
    BAlert,
    BLink,
    BTabs,
    BTab,

    // Local Components
    ContactWireInfoCard,
    UserResponsabilityInfoCard,
    MeasurementsList

  },

  setup() {

      const data = ref(null)

      // Счётчики в карточке кликабельны: открывают вкладку со связанными объектами,
      // чтобы из любой сущности можно было перейти к её составу и обратно.
      const activeTab = ref(0)
      const tabKeys = ['measurement']
      const goTab = key => {
        const index = tabKeys.indexOf(key)
        if (index >= 0) activeTab.value = index
      }

      const { fetchDataUrl } = useContactWire()

      // Re-register module with additional options
      onBeforeMount(() => {

        if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, STORE_MODULE_CONFIG)
      })

        // UnRegister on leave
      onBeforeUnmount(() => {
          if (!store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
      })

      onMounted( async ()=>{
        await store.dispatch(fetchDataUrl, { id: router.currentRoute.params.id })
                .then(response => { data.value = response.data })
                .catch((err) => {})
      })

      return {
        data,
        activeTab,
        goTab,
      }
    },
}
</script>
